import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';
export default function DownloadContent({ data }) {
  return (
    <div className="copy-container">
      { data.topLogo &&
        <Image src="/img/ifit-logo-2022.svg" className="top-logo" alt="" />
      }
      <h2>{ data.header }</h2>
      <p>{ data.primaryCopy }</p>
      { data.secondaryHeader &&
        <p className="secondary-header">{ data.secondaryHeader }</p>
      }
      { data.secondaryCopy &&
        <p>{ data.secondaryCopy }</p>
      }
      <div className="bottom-link">
        { data.appStoreiFitIcon &&
          <Image src="/img/ifit-logo-2022.svg" alt="" />
        }
        <a href="https://itunes.apple.com/us/app/ifit-smart-cardio-equipment/id1274601042?mt=8" target="_blank"><Image src="/img/app-store-light.svg" className="store-link" alt={ I18n.translate('This is a button to download the [ifit] app from the [apple] app Store.', { ifit: 'iFIT', apple: 'Apple' }) } /></a>
        <a href="https://play.google.com/store/apps/details?id=com.ifit.wolf&hl=en" target="_blank"><Image src="/img/play-store-light.svg" className="store-link" alt={ I18n.translate('This is a button to download the [ifit] app from the [google] store.', { ifit: 'iFIT', google: 'Google Play' }) } /></a>
      </div>
      { data.bottomCopy &&
        <div className="bottom-copy" dangerouslySetInnerHTML={{ __html: data.bottomCopy }} />
      }
    </div>
  );
}

DownloadContent.propTypes = {
  data: PropTypes.object.isRequired
};
